import React from 'react'
import { Link } from 'gatsby'

import {
  Layout,
  Header,
  Intro,
  SectionTitle,
  ItemTitle,
  SmallTitle,
} from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            The Loose Change libraries in Figma are a space for product
            designers to share finalized components that are not yet part of the
            Currency Design System as a way to encourage cross-team
            collaboration and re-use. All designers have access to Loose Change
            and can add and publish assets they feel may be beneficial to other
            teams and broadly applicable across products. The Currency team
            monitors component adoption within Loose Change to determine at
            which point popular assets get absorbed into Currency.
          </p>
          <p>
            For light contribution like bug reports and feature requests, visit{' '}
            <Link className="link" to={'/mt/general/reporting/design'}>
              Bug Reporting and Requests
            </Link>
            .
          </p>
        </Intro>
        <SectionTitle>How to Use the Library</SectionTitle>
        <ItemTitle>Finding the Loose Change Files</ItemTitle>
        <p>
          The Loose Change library files are are contained in the Tools and
          Resources team and under the respective brand Exploration Space
          projects within that team.
        </p>
        <ItemTitle>Navigating in the Loose Change Files</ItemTitle>
        <p>
          The structure of the Loose Change files match the structure of the
          Currency system, i.e. it's broken down at an atomic level. There are
          separate pages for Components, Patterns, and specific atomic elements
          like typography and iconography. When adding to Loose Change, it's
          important to follow the organization that users of the design system
          are accustomed to so they know where to find new assets.
        </p>
        <ItemTitle>Adding to the Library</ItemTitle>
        <SmallTitle>Fill Out the Template</SmallTitle>
        <p>
          On the first page of the Loose Change file, there is an asset template
          with a form on the left and empty space on the right. This template
          should be copied to the appropriate page of the Loose Change file.
          From there, fill out the information requested in the form. It's
          important to provide as much context as possible so that users who
          come to the library will know the intention behind an asset. This will
          ensure consistent usage and quicker potential adoption into Currency.
        </p>
        <SmallTitle>Add Your Asset</SmallTitle>
        <p>
          In the blank space to the right, paste the asset you'd like to share.
          Make the asset as generic as possible by removing any product specific
          copy or guidance, but do not use Lorem Ipsum. Use directional language
          to instruct on the asset's proper usage.
        </p>
        <SmallTitle>Create a Component or Style</SmallTitle>
        <p>
          Once the template is filled out, you must make the copied asset a
          component or style so that it can be accessible from the assets panel
          in any working file in Figma.
        </p>
        <div class="c-notification--inline-warning">
          <div class="c-notification__icon">
            <i class="icon icon--exclamation"></i>
          </div>
          <div class="c-notification__content">
            Do not create a component or style until all information in included
            in the template or it may cause inconsistent usage.
          </div>
        </div>
        <p>
          <strong>To create a component:</strong> Right click your asset and
          select "Create component" from the context menu.
        </p>
        <p>
          <strong>To create a style:</strong> Select your asset and in the
          design tab of the right hand panel, click the four square grid in the
          appropriate section (text, color, etc.) and click the plus button.
          Name the style and click create.
        </p>
        <SmallTitle>Publish the New Asset</SmallTitle>
        <p>
          When all information and assets are added, publish the library from
          the file menu. When publishing the library, always add a version note
          explaining what you have added to Loose Change.
        </p>
        <SectionTitle>Updating Contributed Assets</SectionTitle>
        <div class="c-notification--inline-warning">
          <div class="c-notification__icon">
            <i class="icon icon--exclamation"></i>
          </div>
          <div class="c-notification__content">
            Do not keep works in progress in the Loose Change libraries.
            Distrbuting changing files can cause inconsistencies.
          </div>
        </div>
        <p>
          Assets added to Loose Change should be in a state of doneness or
          near-doneness within product files. However, if it is necessary to
          update a product functionally or visually in a way that is not product
          specific, it's imperative that it also be updated in Loose Change to
          avoid versioning issues and inconsistencies.
        </p>
        <p>
          When updating a file, use the Additional Info section or a sticky in
          the asset template to detail the change that was made, when and why.
          Also include this information in the version notes when you publish
          the library. This way, anyone who has placed this asset from Loose
          Change will see the changes reflected immediately.
        </p>
      </Layout>
    </>
  )
}
